export default __webpack_public_path__ + "f9be0f7.png";